import { type FunctionComponent, type ReactNode, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";

type AlertProps = {
  display: boolean;
  title: String | ReactNode;
  classNames?: String;
  duration?: number;
};

export const Alert: FunctionComponent<AlertProps> = (props: AlertProps) => {
  const { classNames, title, display, duration } = props;

  const [show, setShow] = useState(display);

  useEffect(() => {
    if (display != show) {
      setShow(display);
    }
    if (!duration) {
      return;
    }

    const timer: ReturnType<typeof setTimeout> = setTimeout(() => {
      setShow(false);
    }, duration);

    return () => duration > 0 && clearTimeout(timer);
  }, [display]);

  return (
    <Transition
      show={show}
      as={"div"}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={`${classNames} bg-warning text-warning-foreground rounded mb-2 p-3`}>
        {title}
      </div>
    </Transition>
  );
};
